import { z } from "zod";

const PAGE_SIZE = 10;

// Client-side only -- GET /modules/sellable takes no query params at all.
export const catalogSortBySchema = z.enum([
  "nameEn",
  "nameAr",
  "purchasingPrice",
  "sellingPrice",
]);

export const catalogSearchSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(PAGE_SIZE),
  sort: z.enum(["asc", "desc"]).optional(),
  sortBy: catalogSortBySchema.optional(),
  search: z.string().trim().min(1).optional(),
});

export type CatalogSearch = z.infer<typeof catalogSearchSchema>;
export type CatalogSortBy = z.infer<typeof catalogSortBySchema>;
